import type { BillingType, ProductOption } from '../types/catalog'

// Backend returns unit suffixes without leading slash (`'yr'`, `'mo'`); mock
// seed keeps the prototype `'/yr'` / `'/mo'` form. Strip the slash before
// matching so both sources classify into the same cadence bucket.
export function billingTypeFor(item: ProductOption): BillingType {
  const unit = (item.unit ?? '').replace(/^\//, '')
  if (unit === 'yr') return 'annual'
  if (unit === 'mo') return 'monthly'
  return 'otp'
}

export function groupBillingFor(items: ProductOption[]): BillingType | 'mixed' {
  if (items.length === 0) return 'otp'
  const types = new Set(items.map((item) => billingTypeFor(item)))
  if (types.size === 1) return Array.from(types)[0]
  return 'mixed'
}
